import { useState } from 'react';
import Back from 'components/Back';
import {
  Button,
  Card, Container, Form, TextInput,
} from 'nhsuk-react-components';
import { useNavigate, useParams } from 'react-router-dom';
import useFetchTeamMembers from 'queries/fetch/fetchTeamMembers.ts';
import ProgressIndicator from 'components/ProgressIndicator';
import ApiErrorDetails from 'components/ApiErrorDetails';
import { IManageUserPageParams } from 'utils/parameterUtils.ts';
import useUpdateUserDetails from 'queries/mutate/updateUserDetails.ts';

function EditUserDetailsPage() {
  const { teamId, userId } = useParams() as IManageUserPageParams;
  const navigate = useNavigate();
  const updateDetails = useUpdateUserDetails();
  const teamMembers = useFetchTeamMembers();
  const currentUser = teamMembers.data?.[teamId].read.find((t) => t.sub === userId);
  const [error, setError] = useState<Error | null>(null);

  if (!teamMembers.data || !currentUser) {
    return <ProgressIndicator />;
  }

  return (
    <Container>
      <div className="nhsuk-u-margin-top-6 nhsuk-u-margin-bottom-6">
        <Back label="Back to user" backTo={`/admin/${teamId}/manage-user-details/user/${currentUser.sub}`} />
      </div>
      <Form onSubmit={async (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);

        setError(null);
        try {
          await updateDetails.mutateAsync({
            userId: currentUser.sub,
            teamId,
            details: {
              given_name: formData.get('given_name')?.toString() ?? '',
              family_name: formData.get('family_name')?.toString() ?? '',
            },
          });
        } catch (updatePermissionsError) {
          setError(updatePermissionsError as Error);
          return;
        }

        navigate(`/admin/${teamId}/manage-user-details/user/${currentUser.sub}/details/confirmation`);
      }}
      >
        <Card>
          <>
            <h1 className="nhsuk-heading-m nhsuk-u-margin-bottom-4">User details</h1>

            <TextInput
              label="First name"
              name="given_name"
              defaultValue={currentUser.given_name}
            />

            <TextInput
              label="Last name"
              name="family_name"
              defaultValue={currentUser.family_name}
            />
          </>
        </Card>

        <Button>
          Save and continue
        </Button>
        <ApiErrorDetails apiError={error} />
      </Form>
    </Container>
  );
}

export default EditUserDetailsPage;
